import React, {Component} from 'react';
import { RTLTable,RTLCol,RTLButton } from '../RTLKit';
import {Divider, Icon, Button, Row, Tooltip, Form, Col, Pagination, Typography, Collapse} from 'antd';
import {Field, reduxForm} from "redux-form";

import TextField from '../formFields/TextField';
import Loading from '../loading/loading';
import SelectField from "../formFields/SelectField";
import DatePickerField from "../formFields/DatePickerField";

import moment from 'jalali-moment'

const columns = [
    {
        title: 'ردیف',
        dataIndex: 'key',
        sorter: (a, b) => a.key - b.key,
        width:'10%'
    },
    {
        title: 'کد سیستمی',
        dataIndex: 'system_code',
        sorter: (a, b) => a.system_code - b.system_code,
        width:"10%"
    },
    {
        title: 'نوع تراکنش',
        dataIndex: 'trx_type',
        width:"10%"
    },
    {
        title: 'موجودی تکنسین(ریال)',
        dataIndex: 'balance',
        width:"10%",
        className:"price"
    },
    {
        title: 'مبلغ(ریال)',
        dataIndex: 'amount',
        width:"10%",
        className:"price"
    },
    {
        title: 'توضیحات',
        dataIndex: 'description',
    },
  ];

const expandedRowRender = record => <div>{record.extraInfo}</div>;

class List extends Component {

    constructor(props) {
        super(props);
        this.state = {
            role:'',
            searchBoxHidden:true, //hidden=true
            loading:false,
            pageSize:10,
            current: (this.props.list ? this.props.list.pageNumber : 1),
            expandedRowRender,
            filter:[],
            benefetiary:this.props.match.params.userId ? this.props.match.params.userId : ''
        }
        this.__onChangeCounter = this.__onChangeCounter.bind(this)
    }

    componentDidMount() {
        if(this.props.match.params.userId) {
            let userId = this.props.match.params.userId;
            this.props.getList({benefetiary : userId});
            this.props.getUserInfo(userId)
        }else
            this.props.getList();


    }

    /*--- pagination ---*/
    async handlePageChange(pageNumber) {
        this.setState({current: pageNumber});
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:pageNumber}
        }))
        this.props.getList(this.state.filter);
    }

    /*--- fix user list for show in table ---*/
    __fixListForShowInTable() {
        const { Text } = Typography;
        var list = this.props.list;
        var dataSource = []
        let amountType;
        let balanceType;
        let extraInfo;

        if(list && list.lists) {
            for (let i = 0; i < list.lists.length; i++) {
                if(parseInt(list.lists[i].amount) < 0)
                    amountType = "danger"
                else
                    amountType = "success"

                if(parseInt(list.lists[i].balance) < 0)
                    balanceType = "danger"
                else
                    balanceType = "success"

                if(list.lists[i])
                    extraInfo = <RTLCol size="small" key={i+10}>
                            {list.lists[i].status_history[0] ?
                                <Row className="collapseText" key={i+20}>
                                    <RTLCol md={6} key={i+1}>
                                        <strong style={{float: 'right'}}>نام و نام خانوادگی : </strong>
                                        {list.lists[i].status_history[0].fullname}
                                    </RTLCol>

                                    <RTLCol md={6} key={list.lists[i].status_history[0].system_code}>
                                        <strong style={{float: 'right'}}>کد سیستمی : </strong>
                                        {list.lists[i].status_history[0].system_code}
                                    </RTLCol>

                                    <RTLCol md={6} key={i+30}>
                                        <strong style={{float: 'right'}} key={i+1}>توضیحات : </strong>
                                        {list.lists[i].status_history[0].operation_title}
                                    </RTLCol>

                                    <RTLCol md={6} key={i+40}>
                                        <strong style={{float: 'right'}} key={i+1}>تاریخ : </strong>
                                        {moment(list.lists[i].status_history[0].operation_date).format('jYYYY/jM/jD')}
                                    </RTLCol>
                                </Row>
                            :null}
                            {list.lists[i].order ?
                                <Row className="collapseText" key={i+30}>
                                    <RTLCol md={6} key={i+1}>
                                        <strong style={{float: 'right'}}>شماره درخواست : </strong>
                                        {list.lists[i].order.system_code}
                                    </RTLCol>
                                </Row>
                            :null}
                        </RTLCol>
                else
                    extraInfo = ''

                dataSource.push({
                    key: (this.state.pageSize*(list.page_number-1))+(i+1),
                    system_code: list.lists[i].system_code,
                    balance: <Text type={balanceType}>{(list.lists[i].balance).toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</Text>,
                    amount: <Text type={amountType}>{(list.lists[i].amount).toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</Text>,
                    trx_type: this.__translateTransactionType(list.lists[i].trx_type),
                    extraInfo,
                    description: list.lists[i].description,
                });
            }
        }
        return dataSource;
    }

    __translateTransactionType(type){
        switch (type) {
            case 'TRX_IPG_PAYMENT':
                return 'اینترنتی';
            case 'TRX_CHEQUE_PAYMENT':
                return 'چک';
            case 'TRX_POS_PAYMENT':
                return 'دستگاه پوز';
            case 'TRX_CASH_PAYMENT':
                return 'نقدی';
            case 'TRX_ORDER_COST':
                return 'هزینه سفارش';
            case 'TRX_DISCOUNT':
                return 'تخفیف';
            case 'TRX_COMMISSION':
                return 'پورسانت';
            case 'TRX_SETTLEMENT':
                return 'تکمیل شده';
            case 'TRX_CORRECTIVE':
                return 'تراکنش اصلاحی';
            case 'TRX_GIFT_CREDIT':
                return 'اعتبار هدیه';
        }
    }

    __toggleSearchBox(){
        this.setState({
            searchBoxHidden : !this.state.searchBoxHidden
        })
    }

    /*-- search form ---*/
    onFormSubmit(value) {
        if(this.state.trx_type)
            this.setState(prevState  => ({
                filter: { ...prevState.filter,trx_type:this.state.trx_type}
            }))
        if(this.state.order_id)
            this.setState(prevState  => ({
                filter: {...prevState.filter,order_id:this.state.order_id}
            }))
        if(this.state.system_code)
            this.setState(prevState  => ({
                filter: {...prevState.filter,system_code:this.state.system_code}
            }))
        if(this.state.created_from)
            this.setState(prevState  => ({
                filter: {...prevState.filter,created_from:this.state.created_from}
            }))
        if(this.state.created_to)
            this.setState(prevState  => ({
                filter: {...prevState.filter,created_to:this.state.created_to}
            }))
        this.props.handleSubmit(value);
    }

    async __onChangeCounter(current, pageSize) {
        this.setState({size:pageSize});
        await this.setState(prevState  => ({
            filter: {...prevState.filter,page:current,size:pageSize}
        }))
        this.props.getList(this.state.filter);
    }

    __clearFilter() {
        this.props.reset();
        if(this.props.match.params.userId) {
            let userId = this.props.match.params.userId;
            this.props.getList({benefetiary : userId});
        }else
            this.props.getList()
        this.setState({current:1})
    }

    __goBack(){
        this.props.history.goBack()
    }

    render() {
        var _self = this;
        const { searchBoxHidden,pageSize } = this.state;
        const { list } = this.props;

        if(this.props.userInfo)
            var userName = this.props.userInfo.name+' '+this.props.userInfo.family;

        return (
            <div>
                <Row type="flex">
                    <RTLCol xs={24} md={21}>
                        <Divider orientation="left">لیست تراکنش ها{userName ? 'ی '+userName : null}</Divider>
                    </RTLCol>
                    <RTLCol xs={24} md={3} >
                        <RTLButton type="primary" className="userListBtn" shape="round" icon="search" onClick={this.__toggleSearchBox.bind(this)} ></RTLButton>
                    </RTLCol>
                </Row>
                <Row>
                    <Form name="search" onSubmit={this.onFormSubmit.bind(this)} className="login-form">
                        <Row gutter={4} type="flex" justify="start" align="top" hidden={searchBoxHidden} >
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="trx_type"
                                    component={SelectField}
                                    placeholder="نوع تراکنش"
                                    list={[
                                        {label:'اینترنتی',value:'TRX_IPG_PAYMENT',i:1},
                                        {label:'چک',value:'TRX_CHEQUE_PAYMENT',i:2},
                                        {label:'دستگاه پوز',value:'TRX_POS_PAYMENT',i:3},
                                        {label:'نقدی',value:'TRX_CASH_PAYMENT',i:4},
                                        {label:'هزینه سفارش',value:'TRX_ORDER_COST',i:5},
                                        {label:'تخفیف',value:'TRX_DISCOUNT',i:6},
                                        {label:'پورسانت',value:'TRX_COMMISSION',i:7},
                                        {label:'تکمیل شده',value:'TRX_SETTLEMENT',i:8},
                                        {label:'تراکنش اصلاحی',value:'TRX_CORRECTIVE',i:9},
                                        {label:'اعتبار هدیه',value:'TRX_GIFT_CREDIT',i:10},
                                    ]}
                                    onChange={(trx_type) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,trx_type:trx_type}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="order_id"
                                    component={TextField}
                                    placeholder="شماره درخواست"
                                    onBlur={(order_id) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,order_id:order_id.target.value}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="created_from"
                                    component={DatePickerField}
                                    placeholder="ار تاریخ"
                                    timePicker={false}
                                    onChange={(created_from) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,created_from:created_from}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={12} md={5}>
                                <Field
                                    name="created_to"
                                    component={DatePickerField}
                                    placeholder="تا تاریخ"
                                    timePicker={false}
                                    onChange={(created_to) => this.setState(prevState  => ({
                                        filter: {...prevState.filter,created_to:created_to}
                                    }))}
                                />
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                <RTLButton className="left" type="default" shape="round" onClick={this.__clearFilter.bind(this)}>
                                    بروزرسانی
                                </RTLButton>
                            </RTLCol>
                            <RTLCol sm={24} md={2}>
                                 <RTLButton loading={this.props.common.isProgressing} className="left" type="primary" shape="round" htmlType="submit">
                                    جستجو
                                </RTLButton>
                            </RTLCol>
                        </Row>
                    </Form>
                </Row>
                <Row>
                    <RTLTable rowClassName={(record, index) => (index+1)%2 == 0 ? 'even' : 'odd' } {...this.state} pagination={false} columns={columns} dataSource={this.__fixListForShowInTable()} size="small" />
                    <Loading list={list} />
                </Row>
                <Row type="flex" justify="space-between">
                    <RTLCol md={14} className="right">
                        <Pagination
                            name="pageNum"
                            current={this.state.current}
                            total={(list ? list.count : 10)}
                            onChange={(pageNum) => this.handlePageChange(pageNum)}
                            pageSizeOptions = {['10','20','50','100']}
                            showSizeChanger
                            onShowSizeChange={this.__onChangeCounter}
                        />
                    </RTLCol>
                    <RTLButton onClick={this.__goBack.bind(this)} className="backBtn2" type="default" >
                        بازگشت
                    </RTLButton>
                </Row>
            </div>
        );
    }
}

export default List = reduxForm({
    form: 'list'
})(List)
